import React from "react";
import UAParser from "ua-parser-js";
import { GetServerSideProps, InferGetServerSidePropsType } from "next";

import { SERVER } from "../../src/common/config/utils";
import PageError, {
  onError,
} from "../../src/common/components/error-handlers/PageError";
import Meta from "../../src/common/components/seo/meta/Meta";
import Banner from "../../src/apps/components/list/banner/Banner";
import Categories from "../../src/apps/components/list/categories/Categories";
import UseCasesList from "../../src/apps/components/list/UseCasesList";
import { APPS_LIST_PAGE_OG_IMAGE } from "../../src/apps/utils/constants";

export default function ({
  error,
  banners,
  categories,
  deviceType,
}: InferGetServerSidePropsType<typeof getServerSideProps>) {
  if (error) {
    return <PageError error={error} />;
  }

  return (
    <>
      <Meta
        title="AI Apps for your Everyday Needs"
        siteName="AI Planet App Store"
        description="The AI App Store has several real-world AI-powered apps that improve productivity by 10x. Explore and discover how our intelligent AI apps can enhance productivity, streamline workflows, and more."
        canonicalUrl={`${SERVER}/apps`}
        ogImage={APPS_LIST_PAGE_OG_IMAGE}
      />
      <Banner banners={banners} deviceType={deviceType} />
      {/* this div is added to handle explore cta of banner */}
      <div id="explore" />
      <Categories categories={categories} deviceType={deviceType} />
      <UseCasesList categories={categories} />
    </>
  );
}

export const getServerSideProps: GetServerSideProps = async ({
  req,
  resolvedUrl,
}) => {
  try {
    const service = new (
      await import("./../../src/common/service/baseServerSideService")
    ).default(req);
    const { data: banners } = await service.get(
      service.buildUrl("/store/learners/banners/")
    );
    const { data: categories } = await service.get(
      service.buildUrl("/store/learners/categories/")
    );

    let userAgent;

    if (req) {
      userAgent = req.headers["user-agent"];
    } else {
      userAgent = navigator.userAgent;
    }

    const parser = new UAParser();
    parser.setUA(userAgent as string);
    const result = parser.getResult();
    console.log(result.device);
    const deviceType = (result.device && result.device.type) || "desktop";

    return {
      props: {
        deviceType,
        banners,
        categories,
        resolvedUrl: resolvedUrl,
      },
    };
  } catch (error) {
    return onError(error);
  }
};
